import React, { useEffect, useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import useMediaQuery from '@mui/material/useMediaQuery';

import UserManagement from './UserManagement';
import UserRequest from './UserRequests'
import RaceManagement from './RaceManagement';
import RaceRequests from './RaceRequests';
import ClubSettings from './ClubSettings';

import { useDecodedToken } from '../app/hooks';

import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Administration(){
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const location = useLocation();
    const isMdScreen = useMediaQuery('(min-width:600px)');

    const decodedToken = useDecodedToken();
    const adminID = decodedToken?.id;
    // This page is only reachable with role === 'ADMIN', which a user with
    // no club membership can never have -- clubId is always a real number
    // here despite the token type allowing null for the no-membership case.
    const clubId = decodedToken?.clubId ?? undefined;

    useEffect(() => {
      const selectedTabFromState = (location.state as { selectedTab?: number } | null)?.selectedTab;

      // If selectedTab is present, update the tab value
      if (selectedTabFromState !== undefined) {
        setValue(selectedTabFromState);
      }
    }, [location.state]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    };

    return (
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Box
          sx={{
            flexGrow: 1,
            bgcolor: 'background.paper',
            display: 'flex',
            flexDirection: isMdScreen ? 'row' : 'column',
          }}
        >
          <Tabs
            orientation={isMdScreen ? 'vertical' : 'horizontal'}
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label={t('administration.tabsAriaLabel')}
            sx={isMdScreen ? { borderRight: 1, borderColor: 'divider' } : { borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab label={t('administration.members')} {...a11yProps(0)} />
            <Tab label={t('administration.requests')} {...a11yProps(1)} />
            <Tab label={t('races.title')} {...a11yProps(2)} />
            <Tab label={t('administration.raceRequests')} {...a11yProps(3)} />
            <Tab label={t('administration.club')} {...a11yProps(4)} />
          </Tabs>
          <TabPanel value={value} index={0}>
            <UserManagement clubId={clubId} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <UserRequest admin={adminID} clubId={clubId} />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <RaceManagement clubId={clubId} />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <RaceRequests clubId={clubId} />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <ClubSettings clubId={clubId} />
          </TabPanel>
        </Box>
      </Container>
    );
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography component={'span'}>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    };
  }


export default Administration;
